import { Component } from '@angular/core';
import { UserService } from '../services/user/user.service';
import { awsconfig, environment, oAuthConfig } from '../../../environments/environment';
import { RuntimeMode } from '../../../environments/environment.type';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from '../services/auth/auth.service';
import { RoutingUtils } from 'src/app/routing/routing.utils';
import { BehaviorSubject } from 'rxjs';
import { AnalyticsService } from '../services/analytics/analytics.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  clickCounter = 0;
  showTestLinks: boolean = environment.runtime === RuntimeMode.DEVELOPMENT;
  isAuthenticated$: BehaviorSubject<boolean>;
  isLocalEnv: boolean = false;
  loginUrl: string;

  constructor(
    private userService: UserService,
    private logger: NGXLogger,
    private authService: AuthService,
    private routingUtils: RoutingUtils,
    private analyticsService: AnalyticsService,
  ) {
    this.isAuthenticated$ = this.authService.isAuthenticated$;
    this.isLocalEnv = environment.name === 'local';
    this.loginUrl = this.authService.ssoUrl();
  }

  async onClickLogout(): Promise<void> {
    this.logger.debug(`onClickLogout clicked`);
    await this.authService.logout();
  }

  async onClickLogin(): Promise<void> {
    this.logger.debug(`onClickLogin clicked`);

    this.analyticsService.pushEvent('login', {
      category: 'Button Click',
      action: 'Login Attempt',
      element: 'Login Button',
      method: 'email_password',
    });

    this.routingUtils.routeToExternalUrl(this.loginUrl);
  }

  /** TEST METHODS */

  async testProtectedAPI(): Promise<void> {
    const res = await this.userService.testProtectedAPI();
    this.logger.debug('testProtectedAPI: ', res);
  }

  async onClickTestAPI(): Promise<void> {
    this.clickCounter += 1;
    this.logger.debug(`onClickTestAPI was called ${this.clickCounter} times`);
    await this.testProtectedAPI();
  }

  async onClickRevokeToken(): Promise<void> {
    this.logger.debug(`onClickRevokeToken clicked`);
    await this.authService.revokeToken();
  }

  async onClickLocalSignOut(): Promise<void> {
    this.logger.debug(`onClickLocalSignOut clicked`);
    await this.authService.signOut();
  }

  async onClickCognitoLogout(): Promise<void> {
    this.logger.debug(`onClickCognitoLogout clicked`);
    const logoutUrl = `${oAuthConfig.domain}/logout?client_id=${awsconfig.Auth.userPoolWebClientId}&logout_uri=${oAuthConfig.logoutURI}`;
    this.logger.debug(`Starting logout to: ${logoutUrl}`);
    this.routingUtils.routeToExternalUrl(logoutUrl);
  }

  async onClickForceRefresh(): Promise<void> {
    this.logger.debug(`onClickForceRefresh clicked`);
    await this.authService.forceRefresh();
  }

  async onClickForceFederatedSignIn(): Promise<void> {
    this.logger.debug(`onClickForceFederatedSignIn clicked`);
    await this.authService.testForcedFederatedSignIn();
  }
}
